module.exports = __webpack_public_path__ + "static/media/Diabetes-Day-2022.db1ee0e2.jpg";